// extracted by mini-css-extract-plugin
module.exports = {"percent":"PercentBlock_percent__14fr3","red":"PercentBlock_red__2x7eW","green":"PercentBlock_green__u5Gxh"};